import apis from "../../core/apis";
import * as auditLists from "./lists";

class AuditorHandler {
  constructor($resource) {
    this.$resource = $resource;
    this.lists = {
      Ride: auditLists.rideList,
    };

    this.format = this.format.bind(this);
  }

  list(params) {
    return this.$resource(apis.auditor)
      .get(params)
      .$promise.then((response) => {
        const hits = response.hits.map(this.format);
        const { total } = response;

        return { total, hits };
      });
  }

  format(item) {
    const list = this.lists[item.resourceType];
    const action = list.find((l) => l.name === item.action);

    item.action = action || { title: item.action };

    if (item.action && typeof item.action.formatter === "function") {
      item.value = item.action.formatter(item.value);
      item.oldValue = item.action.formatter(item.oldValue);
    }

    return item;
  }
}

export default AuditorHandler;



// WEBPACK FOOTER //
// ./src/services/auditorHandler/auditorHandler.service.js